import { forwardRef, type SVGProps } from 'react';

export type FigmaChevronIconProps = {} & Omit<SVGProps<SVGSVGElement>, 'css'>;

export const FigmaChevronIcon = forwardRef<SVGSVGElement, FigmaChevronIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 16 16">
    <path d="M11 8L5 4V12L11 8Z" fill="currentColor" />
  </svg>
));

FigmaChevronIcon.displayName = 'FigmaChevronIcon';
